import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="bg-white text-gray-900 py-12 border-t border-gray-200">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_modern-ideal/artifacts/cjb69lrj_logo_Fustellificio_Ideal_transparent.PNG" 
                alt="Fustellificio Ideal Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-600 mb-4">
              Oltre 30 anni di esperienza nella produzione di fustelle di alta qualità 
              per calzature, pelletteria e settore automobilistico.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-gray-900">Link Rapidi</h3>
            <nav className="space-y-3">
              <Link to="/azienda" onClick={handleLinkClick} className="block text-gray-600 hover:text-blue-600 transition-colors">
                Azienda
              </Link>
              <Link to="/fustelle" onClick={handleLinkClick} className="block text-gray-600 hover:text-blue-600 transition-colors">
                Fustelle
              </Link>
              <Link to="/sviluppo-modelli" onClick={handleLinkClick} className="block text-gray-600 hover:text-blue-600 transition-colors">
                Sviluppo Modelli
              </Link>
              <Link to="/timbri" onClick={handleLinkClick} className="block text-gray-600 hover:text-blue-600 transition-colors">
                Timbri
              </Link>
              <Link to="/contatti" onClick={handleLinkClick} className="block text-gray-600 hover:text-blue-600 transition-colors">
                Contatti
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6 text-gray-900">Contatti</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <MapPin className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <div>
                  <p className="text-gray-600">Viale Europa, 14</p>
                  <p className="text-gray-600">25028 Verolanuova (BS)</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <p className="text-gray-600">030/932158</p>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-600 flex-shrink-0" />
                <a href="mailto:info@fustellificioideal.it" className="text-gray-600 hover:text-blue-600 transition-colors">
                  info@fustellificioideal.it
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-6 mt-8">
          <div className="text-center text-gray-500 text-sm">
            © 2024 Fustellificio Ideal S.n.c. - Tutti i diritti riservati
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;